export default __webpack_public_path__ + "static/media/example-product1.c0195c26.jpeg";